import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap'
import { toast } from 'react-toastify';
import axios from 'api/axios';

import PageHeader from 'components/common/PageHeader';
import DataCard from 'components/mycomponents/DataCard';
import ModalAlert from 'components/mycomponents/ModalAlert';

import Data from './Data';
import RouteForm from './Form';
import RouteFormMap from './FormMap';
import Detail from './Detail';

const Route = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [showFormMap, setShowFormMap] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [pagination, setPagination] = useState({disabledPrev: true, disabledNext: false, pageTotal: 0, currentPage: 1, limit: 10, numberStart: 0});
    const [loadingData, setLoadingData] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});
    const [validateForm, setValidateForm] = useState(false);
    const [defaultLongLat, setDefaultLongLat] = useState([-6.883729232769789, 112.04522597619037]);
    const [routeGeoJSON, setRouteGeoJSON] = useState(null);
    const [formAttribute, setFormAttribute] = useState({
        title: 'Form', 
        type: 'add',
        data: {
            vckode:'',
            vcnama:'',
            titik_rute: null,
            titik_rute_map: null
        }
    });

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/routes';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };

    // function get data
    const getData = async (page = 1, limit = 10) => {
        setLoadingData(true);
        try {
            const response = await axios.get(`${DATA_URL}?q=${keyword}&page=${page}&limit=${limit}`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            const responseDataLength = responseResult?.length;
            const responseDataPageTotal = responseResult?.page_total;

            if (responseDataLength > 0) {
                setData(responseData);
                setPagination(prevState => {
                    return {...prevState, pageTotal: responseDataPageTotal, limit: limit, currentPage: page, numberStart: limit * (page - 1)}
                })
            } else {
                setData(null);
            }
            if (page >= responseDataPageTotal) {
                setPagination(prevState => {
                    return {...prevState, disabledNext: true}
                })
            } else {
                setPagination(prevState => {
                    return {...prevState, disabledNext: false}
                })
            }
            if (page === 1) {
                setPagination(prevState => {
                    return {...prevState, disabledPrev: true}
                })
            }
            setLoadingData(false);
            
        } catch (err) {
            setLoadingData(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    // Get Data On Load
    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const keyword = keywordParam ? keywordParam : '';
        setKeyword(keyword);
    },[])

    // Toggle Form to open and close modal form
    const handleToggleForm = () => {
        setValidateForm(false)
        setFormAttribute(prevState => {
            return {...prevState, data: {
                vckode:'',
                vcnama:'',
                titik_rute: null,
                titik_rute_map: null
            }}
        })
        setShowForm(!showForm);
    }

    // Toggle Form to open and close modal form Map
    const handleToggleFormMap = () => {
        setValidateForm(false)
        setFormAttribute(prevState => {
            return {...prevState, data: {
                vckode:'',
                vcnama:'',
                titik_rute: null,
                titik_rute_map: null
            }}
        })
        setShowFormMap(!showFormMap);
    }

    // Toggle Form to open and close modal detail
    const handleToggleDetail = () => {
        setShowDetail(!showDetail);
    }

    // to open modal form (ADD)
    const handleAdd = () => {
        setFormAttribute(prevState => {
            return {...prevState, title: 'Form Tambah Data', type: 'add'};

        })
        setShowForm(true);
    }

    // to open modal form (UPDATE)
    const handleEdit = async (intid) => {
        setLoadingForm(true);
        try {
            const response = await axios.get(`${DATA_URL}/${intid}`, HEADER_AUTHORIZATION);
            const responseData = response.data;
            const dataTemp = {
                intid: responseData.data.intid,
                vckode: responseData.data.vckode,
                vcnama: responseData.data.vcnama,
                titik_rute: responseData.data.titik_rute,
                titik_rute_map: responseData.data.titik_rute_map
            }

            setFormAttribute(prevState => {
                return {...prevState, data: dataTemp, title: 'Form Ubah Data', type: 'update'}
            })

            setShowForm(true);
            setLoadingForm(false);
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleEditMap = async (intid) => {
        setLoadingForm(true);
        try {
            const response = await axios.get(`${DATA_URL}/${intid}`, HEADER_AUTHORIZATION);
            const responseData = response.data;
            const dataTemp = {
                intid: responseData.data.intid,
                vckode: responseData.data.vckode,
                vcnama: responseData.data.vcnama,
                titik_rute: responseData.data.titik_rute,
                titik_rute_map: responseData.data.titik_rute_map
            }

            setFormAttribute(prevState => {
                return {...prevState, data: dataTemp, title: 'Form Ubah Data', type: 'updateMap'}
            })

            setShowFormMap(true);
            setLoadingForm(false);
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleDelete = (intid) => {
        setFormAttribute(prevState => {
            const dataTemp = {
                intid: intid
            }
            return {...prevState, data: dataTemp, title: 'Form Hapus Data', type: 'delete'}
        })
        setShowAlert(prevState => { return {...prevState, show: true, message: 'Data akan dihapus ?', type: 'warning', confirmButton: true} })
    }

    const handleDetail = async (intid) => {
        setLoadingForm(true);
        try {
            const response = await axios.get(`${DATA_URL}/${intid}`, HEADER_AUTHORIZATION);
            const responseData = response.data;
            const dataTemp = {
                intid: responseData.data.intid,
                vckode: responseData.data.vckode,
                vcnama: responseData.data.vcnama,
                titik_rute: responseData.data.titik_rute
            }

            setFormAttribute(prevState => {
                return {...prevState, data: dataTemp, title: 'Form Ubah Data', type: 'update'}
            })

            setShowDetail(true);
            setLoadingForm(false);
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const addRoutePoint = () => {
        const routePoint = {vcnama:'', declongitude:'', declattitude:''}
        let routePointData = formAttribute.data.titik_rute;
        if (routePointData) {
            routePointData.push(routePoint);
        } else {
            routePointData = [routePoint]
        }

        let formDataTemp = formAttribute.data; 
        formDataTemp['titik_rute'] = routePointData;
        setFormAttribute(prevState => {
            return {...prevState, data: formDataTemp};

        });
    }

    const removeRoutePoint = (index) => {
        let routePointData = formAttribute.data.titik_rute;
        if (routePointData) {
            routePointData.splice(index, 1);
        }

        let formDataTemp = formAttribute.data; 
        formDataTemp['titik_rute'] = routePointData;
        setFormAttribute(prevState => {
            return {...prevState, data: formDataTemp};

        });
    }

    const addRoutePointMap = () => {
        const routePoint = {declongitude:'', declattitude:''}
        let routePointData = formAttribute.data.titik_rute_map;
        if (routePointData) {
            routePointData.push(routePoint);
        } else {
            routePointData = [routePoint]
        }

        let formDataTemp = formAttribute.data; 
        formDataTemp['titik_rute_map'] = routePointData;
        setFormAttribute(prevState => {
            return {...prevState, data: formDataTemp};

        });
    }

    const removeRoutePointMap = (index) => {
        let routePointData = formAttribute.data.titik_rute_map;
        if (routePointData) {
            routePointData.splice(index, 1);
        }

        let formDataTemp = formAttribute.data; 
        formDataTemp['titik_rute_map'] = routePointData;
        setFormAttribute(prevState => {
            return {...prevState, data: formDataTemp};

        });
    }

    const handleChangeForm = (event) => {
        const {value, name} = event.target;
        if (name === 'q') {
            setKeyword(value)
        } else if (name === 'limit') {
            setPagination(prevState => {
                return {...prevState, limit: value}
            })
            const page = 1;
            const keywordSearch = keyword;
            const pathUrl = window.location.pathname;
            const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
            navigate(urlNavigate)
            getData(1, value)
        } else {
            let formDataTemp = formAttribute.data; 
            formDataTemp[name] = value;
            setFormAttribute(prevState => {
                return {...prevState, data: formDataTemp};
    
            })
        }
    }

    const handleChangeFormArray = (event, index, column = '') => {
        const {value, name} = event.target;

        let formDataTemp = formAttribute.data;
        let formDataArrayTemp = formDataTemp[column];
        formDataArrayTemp[index][name] = value
        
        formDataTemp[column] = formDataArrayTemp;
        setFormAttribute(prevState => {
            return {...prevState, data: formDataTemp};

        })
    }

    const handleSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const page = 1;
        const keywordSearch = keyword;
        const pathUrl = window.location.pathname;
        const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
        navigate(urlNavigate)
        getData(page)
    }

    const handleClickPagination = (type) => {
        let count = 0;
        if (type === 'prev') {
            count = -1
        }
        if (type === 'next') {
            count = 1
        }

        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const pageParam = urlParams.get('page');
        const page = pageParam ? parseFloat(pageParam) + count : 2;
        const keywordSearch = keywordParam ? keywordParam : keyword;
        const pathUrl = window.location.pathname;

        if (page > 1) {
            setPagination(prevState => {
                return {...prevState, disabledPrev: false}
            })
        } else {
            setPagination(prevState => {
                return {...prevState, disabledPrev: true}
            })
        }

        const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
        navigate(urlNavigate)
        getData(page, pagination.limit)
    }

    const handleSubmit = (event) => {
        setLoadingForm(true);

        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            setValidateForm(true);
            setLoadingForm(false);
        } else {
            if (formAttribute.type === 'add') {
                createData();
            }
            if (formAttribute.type === 'update') {
                updateData('update');
            }
            if (formAttribute.type === 'updateMap') {
                updateData('updateMap');
            }
        }
    
    };

    const createData = async () => {
        try {
            const response = await axios.post(`${DATA_URL}`, formAttribute.data, HEADER_AUTHORIZATION);
            const responseData = response.data;
            setLoadingForm(false);
            toast.success(`${responseData.message}`, {
                theme: 'colored',
                position: "top-center"
            });
            handleToggleForm();
            getData();
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
        
    }

    const updateData = async (updateType) => {
        try {
            let dataPost = formAttribute.data;
            if (routeGeoJSON) {
                let dataCoordinates = [];
                formAttribute.data.titik_rute_map.forEach(element => {
                    const dataPointTemp = {declongitude: element[0], declattitude: element[1], intrute_angkutan_id: formAttribute.data.intid};
                    dataCoordinates.push(dataPointTemp);
                });
                dataPost['titik_rute_map'] = dataCoordinates;
            }            
            const updateUrl = updateType === 'update' ? DATA_URL : DATA_URL + '/map'
            const response = await axios.put(`${updateUrl}/${formAttribute.data.intid}`, dataPost, HEADER_AUTHORIZATION);
            const responseData = response.data;
            setLoadingForm(false);
            toast.success(`${responseData.message}`, {
                theme: 'colored',
                position: "top-center"
            });

            if (updateType === 'update') {
                handleToggleForm();
            } else if (updateType === 'updateMap') {
                handleToggleFormMap();
            }
            getData();
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const deleteData = async () => {
        try {
            const response = await axios.delete(`${DATA_URL}/${formAttribute.data.intid}`, HEADER_AUTHORIZATION, formAttribute.data);
            const responseData = response.data;
            setLoadingForm(false);
            toast.success(`${responseData.message}`, {
                theme: 'colored',
                position: "top-center"
            });
            getData();
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} });
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} });
            }
        }
    }

    const generateMapRoute = async () => {
        setLoadingForm(true);
        const headerAuthorization = {
            headers: {
                'Accept': 'application/json, application/geo+json, application/gpx+xml, img/png; charset=utf-8',
                'Authorization': '5b3ce3597851110001cf62481db4c58802d14bb8a2226353b31795c0',
                'Content-Type': 'application/json'
            }
        }
        let dataCoordinates = [];
        formAttribute.data.titik_rute.forEach(element => {
            dataCoordinates.push([parseFloat(element.declongitude),parseFloat(element.declattitude)]);
        });
        
        try {
            const response = await axios.post(`https://api.openrouteservice.org/v2/directions/driving-car/geojson`, { coordinates: dataCoordinates }, headerAuthorization);
            const responseData = response.data;
            const longLat = responseData.features[0].geometry.coordinates;
            setRouteGeoJSON(longLat);
            setDefaultLongLat(longLat[0]);
            let formDataTemp = formAttribute.data; 
            formDataTemp['titik_rute_map'] = longLat;
            setFormAttribute(prevState => {
                return {...prevState, data: formDataTemp};

            });
            setLoadingForm(false);
            setShowAlert(prevState => { return {...prevState, show: true, message: 'Generate Rute Berhasil.', type: 'success'} })
        } catch (err) {
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
                setLoadingForm(false);
            } else {
                setLoadingForm(false);
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleConfirmAlert = () => {
        setShowAlert(prevState => { return {...prevState, show: false}});
        if (formAttribute.type === 'delete') {
            deleteData();
        }
    }

    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Data Rute"
                description=""
                className="mb-3"
            >
            </PageHeader>

            {/* Data */}
            <DataCard>
                <DataCard.Header title={''} addButton addAction={handleAdd} keyword={keyword} handleChangeKeyword={handleChangeForm} handleSearch={handleSearch} />
                <DataCard.Body>
                    <Data 
                        dataMain={data} 
                        actionEdit={handleEdit} 
                        actionEditMap={handleEditMap} 
                        actionDelete={handleDelete} 
                        actionDetail={handleDetail} 
                        numberStart={pagination.numberStart} 
                        isLoading = {loadingData}
                    />
                    <Row>
                        <Col sm={2}>
                            <Form.Select
                                name="limit"
                                value={pagination.limit}
                                onChange={handleChangeForm}
                            >
                                <option value={10}>10 Baris</option>
                                <option value={20}>20 Baris</option>
                                <option value={30}>30 Baris</option>
                            </Form.Select>
                        </Col>
                        <Col sm={10}>
                            <div className="float-end">
                                <Button variant="primary" size="sm" disabled={pagination.disabledPrev} onClick={() => handleClickPagination('prev')} className="me-2">Sebelumnya</Button>
                                <Button variant="primary" size="sm" disabled={pagination.disabledNext} onClick={() => handleClickPagination('next')}>Selanjutnya</Button>
                            </div>
                        </Col>
                    </Row>
                </DataCard.Body>
            </DataCard>

            {/* Form */}
            <RouteForm 
                show={showForm}
                handleClose={handleToggleForm}
                formAttribute={formAttribute}
                handleChange={handleChangeForm}
                handleChangeFormArray={handleChangeFormArray}
                handleSubmit={handleSubmit}
                isLoading={loadingForm}
                validate={validateForm}
                addRoutePoint={addRoutePoint}
                removeRoutePoint={removeRoutePoint}
                generateMapRoute={generateMapRoute}
                defaultLongLat={defaultLongLat}
                routeGeoJSON={routeGeoJSON}
            />

            <RouteFormMap 
                show={showFormMap}
                handleClose={handleToggleFormMap}
                formAttribute={formAttribute}
                handleChange={handleChangeForm}
                handleChangeFormArray={handleChangeFormArray}
                handleSubmit={handleSubmit}
                isLoading={loadingForm}
                validate={validateForm}
                addRoutePoint={addRoutePointMap}
                removeRoutePoint={removeRoutePointMap}
                defaultLongLat={defaultLongLat}
                routeGeoJSON={routeGeoJSON}
            />

            {/* Detail Data */}
            <Detail 
                show={showDetail}
                handleClose={handleToggleDetail}
                data={formAttribute.data}
            />

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

Route.propTypes = {}

export default Route;